<template>
  <v-container fluid class="pa-0">

    <v-progress-linear v-if="loading" indeterminate height="1"></v-progress-linear>
    <v-divider v-else style="border-color: rgb(151 151 151 / 12%);" />

    <RouteListItem v-for="(group, index) in emailGroups" :key="index" :node="{
      name: 'EditEmailSetting',
      meta: {
        displayName: group.display,
        icon: 'mdi-email-newsletter',
        params: { key: group.key },
        query: group.query
      }
    }">
    </RouteListItem>

    <!-- <v-divider class="mx-4" style="border-color: rgb(151 151 151 / 12%);" /> -->

  </v-container>
</template>


<script>
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";

export default {
  name: "RouteListItem_Settings",
  props: {
    node: Object,
  },
  components: {
    RouteListItem,
  },

  data() {
    return {
      loading: false,
      emailGroups: [
        { key: 'newjob', display: this.$t('servicesystem.pages.page_titles.email_menu_new_job'), query: { group: "Job", emailEnabledSettingName: "", emailSubjectSettingName: "NewJobEmailSubject", emailbodySettingName: "NewJobEmailBody", titleText: this.$t('servicesystem.common_objects.email_settings.title_new_job') }},
        { key: 'confirmed-customer-support', display: this.$t('servicesystem.pages.page_titles.email_menu_confirmation_support'), query: { group: "Job", emailEnabledSettingName: "SupportJobConfirmationActivated", emailSubjectSettingName: "SupportJobConfirmationEmailSubject", emailbodySettingName: "SupportJobConfirmationEmailBody", titleText: this.$t("servicesystem.common_objects.email_settings.title_confirmation_support_customer") }},
        { key: 'confirmed-email', display: this.$t('servicesystem.pages.page_titles.email_menu_confirmation_appointment'), query: { group: "Order", emailEnabledSettingName: "", emailSubjectSettingName: "OrderConfirmationEmailSubject", emailbodySettingName: "OrderConfirmationEmailBody", titleText: this.$t("servicesystem.common_objects.email_settings.title_confirmation_appointment_customer") }},      
        { key: 'completedJob', display: this.$t('servicesystem.pages.page_titles.email_menu_job_completed'), query: { group: "Job", emailEnabledSettingName: "CompletedJobEmail", emailSubjectSettingName: "CompletedJobEmailSubject", emailbodySettingName: "CompletedJobEmailBody", titleText: this.$t("servicesystem.common_objects.email_settings.title_completed_job") }},        
      ],
    };
  },

  mounted() { },

  methods: {},

  computed: {

  },

  watch: {

  },
};
</script>


<style lang='scss' scoped></style>